import { FundingPolicyType } from './appModel';

export const ILLUSTRATION_TYPICAL_TIMES_SECONDS: Partial<Record<FundingPolicyType, number>> = {
  [FundingPolicyType.secureCareThree]: 100,
  [FundingPolicyType.secureCareFour]: 100,
  [FundingPolicyType.careScoutCareAssurance]: 30,
  [FundingPolicyType.assetCare]: 30,
  [FundingPolicyType.jointAssetCare]: 30,
  [FundingPolicyType.careMattersTwo]: 75,
  [FundingPolicyType.jointCareMatters]: 75,
  [FundingPolicyType.moneyGuardFixedAdvantage]: 90,
};

export const DEFAULT_TYPICAL_TIME_SECONDS = 90;

export function getIllustrationTypicalTime(
  fundingPolicyType: FundingPolicyType | null | undefined,
): number {
  if (!fundingPolicyType) return DEFAULT_TYPICAL_TIME_SECONDS;
  return ILLUSTRATION_TYPICAL_TIMES_SECONDS[fundingPolicyType] ?? DEFAULT_TYPICAL_TIME_SECONDS;
}
